import React from 'react'
import ProgressBar from './ProgressBar.js'
import FormPage1 from './Pages/FormPage1.js'
import FormPage2 from './Pages/FormPage2.js'
import FormPage3 from './Pages/FormPage3.js'



export default function AppForm(props) {

    //Load information from localStorage if it exists
    const localStorageData = localStorage.getItem('kizaboFormData');
    console.log("Local storage data:", localStorageData);
    const savedPageNum = localStorageData ? JSON.parse(localStorageData).pageNum : 1;
    const savedFormData = localStorageData ? JSON.parse(localStorageData).formData : {
        nickname: '',
        email: '',
        country: '',
        consentCheck: false,
        error: {
            nickname: false,
            email: false,
            country: false,
            consentCheck: false,
            sexData: false,
            ageGroupData: false,
            questions: [false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false, false] //thirty falses. One for each question
        },
        questions: [
            { num: "question1", optionAChar: "Extraversion", optionBChar: "Agreeableness", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question2", optionAChar: "Extraversion", optionBChar: "Conscientiousness", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question3", optionAChar: "Extraversion", optionBChar: "Neuroticism", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question4", optionAChar: "Extraversion", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question5", optionAChar: "Agreeableness", optionBChar: "Conscientiousness", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question6", optionAChar: "Agreeableness", optionBChar: "Neuroticism", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question7", optionAChar: "Agreeableness", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question8", optionAChar: "Conscientiousness", optionBChar: "Neuroticism", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question9", optionAChar: "Conscientiousness", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question10", optionAChar: "Neuroticism", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question11", optionAChar: "Extraversion", optionBChar: "Agreeableness", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question12", optionAChar: "Extraversion", optionBChar: "Conscientiousness", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question13", optionAChar: "Extraversion", optionBChar: "Neuroticism", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question14", optionAChar: "Extraversion", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question15", optionAChar: "Agreeableness", optionBChar: "Conscientiousness", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question16", optionAChar: "Agreeableness", optionBChar: "Neuroticism", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question17", optionAChar: "Agreeableness", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question18", optionAChar: "Conscientiousness", optionBChar: "Neuroticism", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question19", optionAChar: "Conscientiousness", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question20", optionAChar: "Neuroticism", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question21", optionAChar: "Extraversion", optionBChar: "Agreeableness", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question22", optionAChar: "Extraversion", optionBChar: "Conscientiousness", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question23", optionAChar: "Extraversion", optionBChar: "Neuroticism", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question24", optionAChar: "Extraversion", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question25", optionAChar: "Agreeableness", optionBChar: "Conscientiousness", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question26", optionAChar: "Agreeableness", optionBChar: "Neuroticism", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question27", optionAChar: "Agreeableness", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question28", optionAChar: "Conscientiousness", optionBChar: "Neuroticism", valueIfA: 1, valueIfB: -1, answer: "" },
            { num: "question29", optionAChar: "Conscientiousness", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: 1, answer: "" },
            { num: "question30", optionAChar: "Neuroticism", optionBChar: "OpennessToExperience", valueIfA: 1, valueIfB: -1, answer: "" },
        ]
    }
    const savedSelectSexData = localStorageData ? JSON.parse(localStorageData).selectSexData : '';
    const savedSelectAgeGroupData = localStorageData ? JSON.parse(localStorageData).selectAgeGroupData : '';

    //Start of the form
    const [pageNum, setPageNum] = React.useState(savedPageNum)

    const [userId, setUserId] = React.useState(null);

    const [formData, setFormData] = React.useState(savedFormData);
    const [selectSexData, setSelectSexData] = React.useState(savedSelectSexData);

    const handleSelectSexChange = (selectedOption) => {
        setSelectSexData(selectedOption);
        // Reset error for the field being changed
        console.log(selectedOption)
        setFormData((oldState) => {
            return {
                ...oldState,
                error: {
                    ...oldState.error,
                    sexData: false,
                }
            }
        })
    }


    const [selectAgeGroupData, setSelectAgeGroupData] = React.useState(savedSelectAgeGroupData);

    const handleSelectAgeGroupChange = (selectedOption) => {
        setSelectAgeGroupData(selectedOption);
        // Reset error for the field being changed
        setFormData((oldState) => {
            return {
                ...oldState,
                error: {
                    ...oldState.error,
                    ageGroupData: false,
                }
            }
        })
    }


    function handleChange(event) {
        const { type, name, value, checked } = event.target;
        const num = parseInt(name.replace("question", ""), 10)
        if (type === "radio") {
            setFormData((oldState) => {
                return {
                    ...oldState,
                    error: {
                        ...oldState.error,
                        questions: oldState.error.questions.map((currentArrayValue, index) => {
                            if (index === num - 1) {
                                return false; // Reset the error for the answered question
                            } else {
                                return currentArrayValue; // Keep the other errors unchanged
                            }
                        })
                    },
                    questions: oldState.questions.map((perQuestion) => {
                        if (perQuestion.num === name) {
                            return {
                                ...perQuestion,
                                answer: value
                            }
                        } else {
                            return perQuestion;
                        }
                    })
                }
            })

        } else {
            setFormData((oldState) => {
                return {
                    ...oldState,
                    [name]: type === "checkbox" ? checked : value,
                    error: {
                        ...oldState.error,
                        [name]: false // Reset error for the field being changed
                    }
                };
            });
        }
    }

    function updateLocalStorage() {
        localStorage.setItem('kizaboFormData', JSON.stringify({
            pageNum: pageNum + 1,
            formData: {
                ...formData
            },
            selectSexData: selectSexData,
            selectAgeGroupData: selectAgeGroupData
        }
        ));
    }

    function checkPageOneErrors(formData, sexData, ageGroupData) {
        //Cycle through all of the fields to check if they're empty or false or not
        const fieldsToCheck = ["nickname", "email", "country", "consentCheck", "sexData", "ageGroupData"];
        const newErrors = {};

        fieldsToCheck.forEach((field) => {
            const value = (field == "sexData") ?
                sexData : (field == "ageGroupData") ?
                    ageGroupData : formData[field];
            if (field === "email") {
                //Check if the email is valid
                const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                newErrors[field] = !emailRegex.test(value);
            } else {
                newErrors[field] = value == '' || value == false;
            }

        });

        //Update the formData and the Select Data
        setFormData((oldState) => {
            return {
                ...oldState,
                error: {
                    ...oldState.error,
                    ...newErrors
                }
            }
        });
        console.log("Checking errors for page 1:", newErrors);
        return (newErrors.nickname || newErrors.email || newErrors.country || newErrors.consentCheck || newErrors.sexData || newErrors.ageGroupData);
    }

    function checkBinaryQuestionErrors(formData) {
        //Get the current page's questions
        const currentPageQuestions = formData.questions.slice(startIndex, startIndex + 3);

        //Check if any of the questions are unanswered
        const unansweredQuestions = currentPageQuestions.filter((question) => question.answer === "");

        //Find the indexes of the unanswered questions. Outputs ["question1", "question2", "question3"]
        const unansweredObjectIndexes = unansweredQuestions.map((question) => question.num);


        //Parsing the questionNum (ex: "question1") to just the number (ex: 1)
        /*const unansweredIndexes = unansweredObjectIndexes.map((questionNum) => parseInt(questionNum.replace("question", ""), 10))
        console.log("Unanswered questions:", unansweredIndexes);*/

        unansweredObjectIndexes.forEach((questionNum) => {
            const num = parseInt(questionNum.replace("question", ""), 10)

            setFormData((oldState) => {
                return {
                    ...oldState,
                    error: {
                        ...oldState.error,
                        questions: oldState.error.questions.map((currentArrayValue, index) => {
                            if (index === num - 1) {
                                return true; // Set the error for the unanswered question to true
                            } else {
                                return currentArrayValue; // Keep the other errors unchanged
                            }
                        })
                    }
                }
            })
        })

        //If there are unanswered questions, we want to return true
        return unansweredObjectIndexes.length > 0;
    }

    function checkErrors() {
        //If page 1, we want to check first if everything was filled out correctly
        if (pageNum === 1) {
            //If there are errors, we do not want to increment the pageNum

            // initially, selectSexData.value is undefined, so we need to check if it exists
            const workaroundSexData = (selectSexData === '') ? selectSexData : selectSexData.value
            const workaroundAgeGroupData = (selectAgeGroupData === '') ? selectAgeGroupData : selectAgeGroupData.value
            if (checkPageOneErrors(formData, workaroundSexData, workaroundAgeGroupData)) {
                console.log("Errors found, not incrementing pageNum");
                return true;
            } else {
                console.log("No errors found, incrementing pageNum");
                return false;
            }
        } else if (pageNum > 1 && pageNum < 12) {
            //If page 2 or higher, we want to check the binary questions if they were answered
            if (checkBinaryQuestionErrors(formData)) {
                console.log("Errors found, not incrementing pageNum");
                return true;
            } else {
                console.log("No errors found, incrementing pageNum");
                return false;
            }
        }
    }

    function incrementPage() {

        updateLocalStorage()
        setPageNum((prevPageNum) => {
            return prevPageNum + 1
        })
    }

    function handleNext() {
        console.log("Next button clicked");
        if (!checkErrors()) { incrementPage(); }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    function handleBack() {
        console.log("Back button clicked");
        setPageNum((prevPageNum) => {
            return prevPageNum - 1
        })
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }



    function handleSubmit(event) {
        event.preventDefault();

        //If there are no errors, then submit the form
        if (!checkErrors()) {
            props.handleTogglePopup({ show: true, type: "loading", });
            //if successful, increment pageNum to 12
            console.log('Form submitted');
            fetch(`${process.env.REACT_APP_BACKEND_URL}/api/v1/submit/`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': process.env.REACT_APP_KIZABO_API_KEY },
                body: JSON.stringify({
                    ...formData,
                    sex: selectSexData.value,
                    age_group: selectAgeGroupData.value
                })
            }).then(response => {
                if (!response.ok) {
                    props.handleTogglePopup({ show: true, type: "error", });
                    throw new Error('Network response was not ok');
                }
                return response.json(); // parse JSON body
            }).then(data => {
                console.log("Form submitted successfully", data);
                if (data.message === "Success") {
                    setUserId(data.user_id);
                    localStorage.removeItem("kizaboFormData")
                    setPageNum(12);
                    props.handleTogglePopup({ show: false, type: "loading", });
                    window.scrollTo({ top: 0, behavior: 'smooth' });
                }
            });
        }
    }

    //Limits the pages being shown to just 3 questions at a time
    const startIndex = ((pageNum - 1) * 3) - 3;


    return (
        <div className="AppForm">
            <div className="AppForm--header">
                <div className="AppForm--logo-space"></div>
                <ProgressBar
                    pageNum={pageNum}
                />
            </div>
            <form className="AppForm--inputs-container" onSubmit={handleSubmit}>
                {(pageNum === 1) && <FormPage1
                    style={{ display: pageNum === 1 ? 'block' : 'none' }}
                    handleNext={handleNext}
                    handleBack={handleBack}
                    formData={formData}
                    handleChange={handleChange}
                    selectSexData={selectSexData}
                    handleSelectSexChange={handleSelectSexChange}
                    selectAgeGroupData={selectAgeGroupData}
                    handleSelectAgeGroupChange={handleSelectAgeGroupChange}
                    pageNum={pageNum}
                />
                }
                {((pageNum > 1) && (pageNum < 12)) && <FormPage2
                    handleNext={handleNext}
                    handleBack={handleBack}
                    formData={formData}
                    handleChange={handleChange}
                    pageNum={pageNum}
                    startIndex={startIndex}
                />}
                {(pageNum === 12) && <FormPage3
                    email={formData.email}
                    userId={userId}
                />}
                <div className="Form--submit-container">
                    {/*First and last pages should not have a back button*/}
                    {((pageNum !== 1) && (pageNum !== 12)) && <button className="Form--back-button" type="button" onClick={handleBack}>Back</button>}

                    {/*If second to the last page, show SUBMIT instead of NEXT */}
                    {(pageNum < 11) && <button className="Form--submit-button" type="button" onClick={handleNext}>Next</button>}
                    {(pageNum == 11) && <button className="Form--submit-button" type="submit">Submit</button>}
                </div>
            </form>
            <div className="AppForm--bottom-space"></div>

        </div>
    )
}